import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Snackbar, Alert, Button } from '@mui/material';
import { supabase } from '../supabaseClient';
import { useAuth } from '../AuthContext';

// Global popup that lets a rep jump straight to the caller's CRM page when
// the Call Bridge app on their phone logs a new inbound call - only works
// while this tab is open (a Realtime subscription, not a push notification).
const IncomingCallAlert = () => {
  const { currentUser } = useAuth();
  const navigate = useNavigate();
  const [call, setCall] = useState(null);

  useEffect(() => {
    if (!currentUser?.id) return undefined;

    const channel = supabase
      .channel(`call-logs-${currentUser.id}`)
      .on(
        'postgres_changes',
        { event: 'INSERT', schema: 'public', table: 'call_logs', filter: `employee_id=eq.${currentUser.id}` },
        async (payload) => {
          const row = payload.new;
          if (row.direction !== 'inbound') return;

          let clientName = null;
          if (row.client_id) {
            const { data } = await supabase
              .from('clients')
              .select('name, showroom_name')
              .eq('id', row.client_id)
              .single();
            clientName = data?.showroom_name || data?.name || null;
          }
          setCall({ phone: row.phone, clientId: row.client_id, clientName });
        }
      )
      .subscribe();

    return () => {
      supabase.removeChannel(channel);
    };
  }, [currentUser?.id]);

  const openClientPage = () => {
    if (call?.clientId) navigate(`/clients/${call.clientId}`);
    setCall(null);
  };

  return (
    <Snackbar
      open={!!call}
      autoHideDuration={15000}
      onClose={() => setCall(null)}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
    >
      <Alert
        severity="info"
        onClose={() => setCall(null)}
        action={
          call?.clientId ? (
            <Button color="inherit" size="small" onClick={openClientPage}>
              فتح الصفحة
            </Button>
          ) : undefined
        }
      >
        {call?.clientId
          ? `مكالمة من ${call.clientName || 'عميل'} - ${call.phone}`
          : `مكالمة من رقم غير مسجل: ${call?.phone || ''}`}
      </Alert>
    </Snackbar>
  );
};

export default IncomingCallAlert;
